import { render, staticRenderFns } from "./couserwareAnalysis.vue?vue&type=template&id=7a849d1a&scoped=true&"
import script from "./couserwareAnalysis.vue?vue&type=script&lang=js&"
export * from "./couserwareAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./couserwareAnalysis.vue?vue&type=style&index=0&id=7a849d1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a849d1a",
  null
  
)

export default component.exports